<div class="timer-container" [ngStyle]="{ color: remainingTime < 0 ? 'red' : 'green' }">
    <span class="fa fa-clock-o"></span> {{ formatTime(remainingTime) }}
</div>
